import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  InputLabel,
  Grid,
  Typography,
  Slider
} from '@material-ui/core';

const cpuMarks = [
  {
    value: 2000,
    label: '2'
  },
  {
    value: 3000,
    label: '3'
  },
  {
    value: 4000,
    label: '4'
  },
  {
    value: 5000,
    label: '5'
  },
  {
    value: 6000,
    label: '6'
  },
  {
    value: 7000,
    label: '7'
  },
  {
    value: 8000,
    label: '8'
  }
];
const memoryMarks = [
  {
    value: 2000,
    label: '2000'
  },
  {
    value: 3000,
    label: '3000'
  },
  {
    value: 4000,
    label: '4000'
  },
  {
    value: 5000,
    label: '5000'
  },
  {
    value: 6000,
    label: '6000'
  },
  {
    value: 7000,
    label: '7000'
  },
  {
    value: 8000,
    label: '8000'
  }
];

const resourceSizeMap = {
  small: 2000,
  medium: 4000,
  large: 6000,
  xlarge: 8000
};

const sizes = ['small', 'medium', 'large', 'xlarge', 'custom'];
export const diskSizes = ['small', 'medium', 'large', 'xlarge'];
const sizeRank = { small: 1, medium: 2, large: 3, xlarge: 4 };

function getResourcesSize(resourceSize) {
  return resourceSizeMap[resourceSize];
}

// returns the label depending of the size of the LRU
export function getSizeLabel(size) {
  if (size === 'small') {
    return `${size} (default)`;
  }
  return size;
}

VMSize.propTypes = {
  updateCurrentVM: PropTypes.func,
  currentVM: PropTypes.object,
  memoryKey: PropTypes.string,
  cpuKey: PropTypes.string,
  minCPU: PropTypes.number,
  minMemory: PropTypes.number,
  minSize: PropTypes.string,
  restrictSize: PropTypes.bool
};

export function VMSize({
  updateCurrentVM,
  currentVM,
  memoryKey,
  cpuKey,
  minCPU,
  minMemory,
  minSize,
  restrictSize
}) {
  const allowedSizes = restrictSize
    ? sizes.filter((s) => s === 'custom' || sizeRank[s] >= sizeRank[minSize])
    : sizes;
  const setSize = (event) => {
    const s = event.target.value;
    // if not custom, update the disk, memory, and cpu size accordingly
    if (s !== 'custom') {
      const newVM = {
        ...currentVM,
        size: s,
        diskSize: s,
        [memoryKey]: getResourcesSize(s),
        [cpuKey]: getResourcesSize(s)
      };
      updateCurrentVM(newVM);
    } else {
      const newVM = {
        ...currentVM,
        size: s
      };
      updateCurrentVM(newVM);
    }
  };

  const setMemoryLimit = (event) => {
    const newVM = { ...currentVM, [memoryKey]: Number(event.target.value) };
    updateCurrentVM(newVM);
  };

  const setCPULimit = (event) => {
    const newVM = { ...currentVM, [cpuKey]: event.target.value };
    updateCurrentVM(newVM);
  };

  const isCustom = () => currentVM.size === 'custom';

  let memoryMin = memoryMarks[0].value;

  if (memoryKey !== 'min_memory' && minMemory > memoryMarks[0].value) {
    memoryMin = minMemory;
  }

  let cpuMin = cpuMarks[0].value;

  if (cpuKey !== 'min_cpu' && minCPU > cpuMarks[0].value) {
    cpuMin = minCPU;
  }
  return (
    <Grid container item xs={12} spacing={2}>
      <Grid item xs={12} sm={6}>
        <FormControl data-testid="vm-size">
          <InputLabel id="size-label">Instance Size</InputLabel>
          <Select
            labelId="size-label"
            label="Instance Size"
            value={currentVM.size}
            onChange={setSize}
            fullWidth
          >
            {allowedSizes.map((el) => (
              <MenuItem key={el} value={el}>
                {getSizeLabel(el)}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>
            The instance size will affect the disk size and resource limits
          </FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} sx={{ ml: 2 }}>
        <Typography variant="subtitle2">CPU Limit (# cores)</Typography>
        <Slider
          aria-label="CPULimit"
          sx={{ marginLeft: 1.2, width: '90%', maxWidth: 400 }}
          valueLabelDisplay="auto"
          marks={cpuMarks}
          max={cpuMarks.at(-1).value}
          min={cpuMin}
          step={null}
          value={currentVM[cpuKey]}
          onChange={setCPULimit}
          disabled={!isCustom()}
          size="small"
        />
        <Typography variant="subtitle2">Memory Limit (MB)</Typography>
        <Slider
          aria-label="MemoryLimit"
          sx={{ marginLeft: 1.2, width: '90%', maxWidth: 400 }}
          valueLabelDisplay="auto"
          marks={memoryMarks}
          max={memoryMarks.at(-1).value}
          min={memoryMin}
          step={500}
          value={currentVM[memoryKey]}
          onChange={setMemoryLimit}
          disabled={!isCustom()}
          size="small"
        />
      </Grid>
    </Grid>
  );
}
